<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t($route.name))"
      icon="mdi-package-variant"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      :create-label="$t(type)"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo(type)"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      <v-menu offset-y left>
        <template v-slot:activator="{ attrs, on }">
          <button type="button" class="pl-btn pl-btn--icon" v-bind="attrs" v-on="on">
            <v-icon size="16">mdi-dots-vertical</v-icon>
          </button>
        </template>
        <v-list dense>
          <log
            v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          
          
          
          
        </v-list>
      </v-menu>
      </template>
      <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <template #top>
<v-chip-group
      ref="listSummary"
      v-model="dateType"
      class="app-list-summary-row app-list-summary-chips"
      mandatory
      active-class="primary--text"
    >
      <v-chip
        value="today"
        small
      >
        {{ $t('today') }}
      </v-chip>
      <v-chip
        value="week"
        small
      >
        {{ $t('week') }}
      </v-chip>
      <v-chip
        value="month"
        small
      >
        {{ $t('month') }}
      </v-chip>
      <v-chip
        value="wholePeriod"
        small
      >
        {{ $t('wholePeriod') }}
      </v-chip>
    </v-chip-group>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="productItemsListColumnPlugins"
        v-column-drag="productItemsListColumnPlugins"
        v-column-pin="productItemsListColumnPlugins"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        v-model="selected"
        :headers="tableHeaders"
        :items="items"
        :page.sync="page"
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :loading="false"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                class="pl-action-cell__btn" icon x-small
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
                        <v-list dense>
              <v-list-item
                link
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                link
                @click="print(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/' + type +'/edit/' + item.head.uid"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
            </v-list>
          </v-menu>
            <span class="pl-action-cell__row"><a @click="edit(item)">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </a></span>
          </div>
        </template>
        <template v-slot:item.price.price="{ item }">
          {{ $numberFormat((item.price ? item.price.price : 0)) }} {{ item.currency.symbol }}
        </template>
        <template v-slot:item.head.doc_header.number="{ item }">
          <a
            v-if="item.head.doc_header"
            @click="openComponent('accountingPrint', item.head.doc_head_id)"
          >
            {{ item.head.doc_header.number }}
          </a>
        </template>
        <template v-slot:item.head.customer.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('account', item.head.customer_id)"
            >
              {{ item.head.customer.name }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('accountingTurnover', item.head.customer.fin_id)"
                >
                  <v-icon
                    color="teal"
                    style="font-size: 22px"
                  >
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('turnover') }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.product.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('product', item.product_id)"
            >
              {{ item.product.name }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('productTurnover', item.product_id)"
                >
                  <v-icon
                    color="teal"
                    style="font-size: 22px"
                  >
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('productTurnover') }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.pre_invoice="{ item }">
          <v-icon
            v-if="item.pre_invoice == 'active'"
            color="green"
          >
            mdi-check
          </v-icon>
        </template>
        <template v-slot:item.count="{ item }">
          {{ $numberFormat((item.count ? item.count : 0)) }}
        </template>
        <template v-slot:item.fee="{ item }">
          {{ $numberFormat((item.fee ? item.fee : 0)) }}
          <v-chip small>
            {{ item.head.currency.name }}
          </v-chip>
        </template>
        <template v-slot:item.tax="{ item }">
          {{ $numberFormat((item.tax ? item.tax : 0)) }}
        </template>
        <template v-slot:item.discount="{ item }">
          {{ $numberFormat((item.discount ? item.discount : 0)) }}
        </template>
        <template v-slot:item.sumCurrency="{ item }">
          {{ $numberFormat(item.sumCurrency) }}
          <v-chip small>
            {{ item.head.currency.name }}
          </v-chip>
        </template>
        <template v-slot:item.sum_amount="{ item }">
          {{ $numberFormat((item.sum_amount ? item.sum_amount : 0)) }}
        </template>
        <template v-slot:item.sum_discount="{ item }">
          {{ $numberFormat((item.sum_discount ? item.sum_discount : 0)) }}
        </template>
        <template v-slot:item.sum_tax="{ item }">
          {{ $numberFormat((item.sum_tax ? item.sum_tax : 0)) }}
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.number="{ item }">
          <a @click="edit(item)">
            {{ item.number }}
          </a>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="(item.head && item.head.tags) || []" />
        </template>
        <template
          v-slot:body.append
        >
          <tr
            v-if="isMobile || isTablet || mobileShow"
            :class="{'v-data-table__mobile-table-row':isMobile}"
          >
            <td
              :colspan="`${isMobile?6:Number(showHeaders.length) - 3}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('count') + ':' : '') }} {{ $numberFormat(totals.count, 10) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('discount') + ':' : '') }} {{ $numberFormat(totals.discount, 10) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('tax') + ':' : '') }} {{ $numberFormat(totals.tax, 10) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('fee') + ':' : '') }} {{ $numberFormat(totals.fee, 10) }}
            </td>
          </tr>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <!-- Desktop fixed viewport: page totals sit above pagination, outside body scroll -->
          <div
            v-if="!isMobile && !isTablet && !mobileShow"
            class="app-list-page-totals"
          >
            <span class="app-list-page-totals__label">{{ $t('sum') }}</span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t('count') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.count, 10) }}
              </span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t('discount') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.discount, 10) }}
              </span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t('tax') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.tax, 10) }}
              </span>
            </span>
            <span
              class="app-list-page-totals__item app-list-page-totals__item--final"
            >
              <span class="app-list-page-totals__key">{{ $t('fee') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.fee, 10) }}
              </span>
            </span>
          </div>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t($route.name))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      :create-label="$t(type)"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo(type)"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t($route.name))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :product-items-invoice="totals"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="invoicePrintDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="invoicePrintDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <invoicprint
            :id-prop="printId"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ productItemsFilterTitle }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-package-variant</v-icon>
              {{ $t("sellFilterParties") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="product"
                type="product"
                :title="$t('product')"
                :outlined="true"
              />
              <status
                v-model="sellStatus"
                :hideconfig="true"
              />
              <autocomplete
                v-model="currencyFilter"
                :title="$t('currency')"
                type="currency"
                :filter="true"
                :multiple="true"
              />
              <tag v-model="tag" />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-calendar-range</v-icon>
              {{ $t("accFilterDateTime") }}
            </div>
            <div class="acf-grid acf-grid--4">
              <div>
                <v-text-field
                  id="fromId"
                  v-model="fromDate"
                  :label="$t('from') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-start"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDate"
                  element="fromId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toId"
                  v-model="toDate"
                  :label="$t('until') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-end"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDate"
                  element="toId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <money
                v-model="fromAmount"
                :dense="true"
                :label="$t('from') + ' ' + $t('amount')"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="dense"
              />
              <money
                v-model="toAmount"
                :dense="true"
                :label="$t('until') + ' ' + $t('amount')"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="dense"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-numeric</v-icon>
              {{ $t("accFilterNumberAmount") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <v-text-field
                v-model="fromNumber"
                :label="$t('from') + ' ' + $t('number')"
                outlined
                dense
                clearable
                hide-details
              />
              <v-text-field
                v-model="toNumber"
                :label="$t('until') + ' ' + $t('number')"
                outlined
                dense
                clearable
                hide-details
              />
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-shape-outline</v-icon>
              {{ $t("productEntrepotFilterGroups") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="group"
                :title="$t('main-group')"
                type="productGroup"
                :data="JSON.stringify({parent:null,type:'group'})"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="cat1"
                :title="$t('other-group')"
                type="productGroup"
                :data="JSON.stringify({parent:null,type:'category'})"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="cat2"
                title="category"
                type="productGroup"
                :data="JSON.stringify({parent:null,type:'subcategory'})"
                :multiple="true"
                :filter="true"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-office-building-outline</v-icon>
              {{ $t("sellFilterOrg") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="branch"
                title="branch"
                type="branch"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="entrepot"
                title="entrepot"
                type="entrepot"
                :filter="true"
                :multiple="true"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-group</v-icon>
              {{ $t("reportFilterGrouping") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <div class="acf-switch">
                <span class="acf-switch__label">{{ $t("groupPerProductGroup") }}</span>
                <v-switch
                  v-model="groupPerProductGroup"
                  class="acf-switch__control mt-0 pt-0"
                  value="active"
                  color="primary"
                  dense
                  inset
                  hide-details
                  :ripple="false"
                />
              </div>
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
    <div
      ref="refPrint"
      style="display: none"
    >
      <div style="color: #000000">
        <table
          id="printTable"
          style="width:100%;border-collapse: collapse;font-size: 10px !important;"
        >
          <thead>
          <tr>
            <td
              colspan="5"
              align="center"
              style="font-size: 16px;font-weight: bold"
            >
              {{ $store.state.abrName }}
            </td>
          </tr>
          <tr>
            <td
              colspan="5"
              style="font-size: 10px;"
            >
              <div style="display: grid;">
                <div>
                  {{ $t('reoprtProductOrService') }} - {{( start  ? start : '')}} {{(dateType !== 'today' && end  ? '~' + end : '')}}
                </div>
              </div>
            </td>
          </tr>
          <tr class="table-header-print">
            <td align="center">
              #
            </td>
            <td align="center">
              {{ $t('product') }}/ {{ $t('service') }}
            </td>
            <td align="center">
              تعداد / وزن
            </td>
            <td align="center">
              {{ $t('fee') }}
            </td>
            <td align="center">
              {{ $t('sum') }}
            </td>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(item, i) in items"
            :key="i"
          >
            <td>{{ i + 1 }}</td>
            <td style="color: #000000">
              {{ (groupPerProductGroup ? (item.product && item.product.group ? item.product.group.name : '') : (item.product ? item.product.name : '') ) }}
            </td>
            <td align="center">
              {{ item.sum_count }}
            </td>
            <td align="center">
              {{ $numberFormat(toFixedWithoutZeros(item.sum_amount / item.sum_count, 0)) }}
            </td>
            <td align="center">
              {{ $numberFormat(item.sum_amount) }}
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="2">
              {{ $t('sum') }}
            </td>
            <td
              colspan="1"
              align="center"
              style="font-weight: bold"
            >
              {{ $numberFormat(totals.sum_count) }}
            </td>
            <td colspan="1">
            </td>
            <td
              colspan="1"
              align="center"
              style="font-weight: bold"
            >
              {{ $numberFormat(totals.sum_amount) }} {{ $store.state.currency.name }}
            </td>
          </tr>
          </tfoot>
        </table>
        <div
          v-if="$store.state.allConfig"
          align="center"
          style="font-size: 11px;margin-top: 5px"
        >
          {{ $store.state.allConfig.address }} {{ ($store.state.allConfig.phone ? '-' + $store.state.allConfig.phone : '') }}
        </div>
        <div
          align="center"
          style="font-size: 8px"
        >
          abriron.com - راهکار های مالی ابرآیرون
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import Invoicprint from './print'
  import General from '../../../../Mixins/general'
  import {
    applyColumnSettings,
    loadColumnSettings,
  } from '@/plugins/columnSettings/columnSettings'
  import { reorderPinnedHeaders } from '@/plugins/columnPin/columnPin'
  import ProList from "@/Mixins/proList";
  import ProListFrame from "@/components/proList/ProListFrame.vue";
  import ProListMobile from "@/components/proList/ProListMobile.vue";
  import PrintStudio from "@/modules/print/PrintStudio.vue";
  export default {
    name: 'InvoiceProductItemList',
    components: {
      ProListFrame,
      ProListMobile,
      PrintStudio,
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      dialogComponent: () => import('../../components/general/dialog/index'),
      Invoicprint,
      Print,
      Task,
    },
    mixins: [General, ProList],
    props: ['input', 'refId', 'mobileShow'],
    data: () => ({
      excelItems: [],
      selected: [],
      invoicePrintDialog: false,
      printDialog: false,
      deletDialog: false,
      dateType: null,
      start: null,
      end: null,
      cat2: null,
      cat1: null,
      group: null,
      entrepot: null,
      product: null,
      dialogData: null,
      account: null,
      currencyFilter: null,
      fromAmount: null,
      toAmount: null,
      fromNumber: null,
      toNumber: null,
      fromDate: null,
      toDate: null,
      printId: null,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      pageCount: 1,
      page: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 500,
      },
      // Table pagination options. Kept separate from `options` because the
      // General mixin reuses `options` for money formatting (filter Money fields)
      // and overwrites it — which dropped page/itemsPerPage for the table.
      // This page intentionally uses 500 items per page (see mounted).
      tableOptions: {
        page: 1,
        itemsPerPage: 500,
      },
      groupPerProductGroup: null,
      headers: null,
      listViewportObserver: null,
      listViewportRaf: null,
      type: null,
      search: null,
      selectedHeaders: [],
      headersMap: null,
    }),
    computed: {

      productItemsFilterTitle () {
        var map = {
          sellIProductItemsList: 'sellProductItemsFilterTitle',
          sellIProductGroupItemsList: 'sellProductGroupItemsFilterTitle',
          returnSellProductItemsList: 'returnSellProductItemsFilterTitle',
          returnPurchaseProductItemsList: 'returnPurchaseProductItemsFilterTitle',
          purchaseProductItemsList: 'purchaseProductItemsFilterTitle',
          presaleProductItemsList: 'presaleProductItemsFilterTitle',
        }
        var key = map[this.$route.name] || 'sellProductItemsFilterTitle'
        return this.$t(key)
      },
      activeFilterChips () {
        var app = this
        var has = function (v) {
          if (Array.isArray(v)) return v.length > 0
          return v !== null && v !== undefined && v !== '' && v !== '0' && v !== 0
        }
        var show = function (v) {
          if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0])
          if (v && typeof v === 'object') return v.name || v.text || v.label || ''
          return typeof v === 'number' || typeof v === 'string' ? String(v) : ''
        }
        var defs = [
          ['product', app.$t('product')],
          ['sellStatus', app.$t('status')],
          ['currencyFilter', app.$t('currency')],
          ['fromAmount', app.$t('from') + ' ' + app.$t('amount')],
          ['toAmount', app.$t('until') + ' ' + app.$t('amount')],
          ['fromNumber', app.$t('from') + ' ' + app.$t('number')],
          ['toNumber', app.$t('until') + ' ' + app.$t('number')],
          ['fromDate', app.$t('from') + ' ' + app.$t('date')],
          ['toDate', app.$t('until') + ' ' + app.$t('date')],
          ['tag', app.$t('tag')],
          ['group', app.$t('main-group')],
          ['cat1', app.$t('other-group')],
          ['cat2', app.$t('category')],
          ['branch', app.$t('branch')],
          ['entrepot', app.$t('entrepot')],
          ['groupPerProductGroup', app.$t('groupPerProductGroup'), app.groupPerProductGroup === 'active' ? app.$t('groupPerProductGroup') : ''],
        ]
        return defs
          .filter(function (d) {
            if (d[0] === 'groupPerProductGroup') return app.groupPerProductGroup === 'active'
            return has(app[d[0]])
          })
          .map(function (d) {
            return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) }
          })
      },
      proListKey () {
        return this.productItemsListColumnPersistKey
      },
      proListLocked () {
        return this.productItemsListLockedColumns
      },
      showSelect () {
        if(!this.isMobile) {
          return true
        } else {
          return false
        }
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      isDesktopListViewport () {
        return !this.isMobile && !this.isTablet && !this.mobileShow
      },
      productItemsListColumnPersistKey () {
        return 'product-items-list-columns-' + (this.$route.name || 'sellIProductItemsList')
      },
      productItemsListLockedColumns () {
        // Fixed sticky block: select + actions + row (no unpin/drag)
        var locked = ['actions']
        return this.showSelect ? ['__select'].concat(locked) : locked
      },
      productItemsListColumnPlugins () {
        // show-select inserts a leading checkbox <th>; pad visibleHeaders so
        // pin/resize/drag index mapping stays aligned with thead cells.
        var selectHeader = {
          value: '__select',
          text: '',
          width: 32,
          sortable: false,
          pinned: false,
          originalIndex: -1,
        }
        var visible = this.showSelect
          ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || []
        return {
          headers: this.headers,
          visibleHeaders: visible,
          locked: this.productItemsListLockedColumns,
          anchor: "actions",
          minWidth: 60,
          persistKey: this.productItemsListColumnPersistKey,
        }
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type === 'purchase' || app.type === 'returnSell') {
            if (s.value === 'cost' || s.value === 'profit') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            if (app.groupPerProductGroup && s.value === 'product.name') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          }
        })
      },
      totals: function () {
        const totals = this.items.reduce((acc, d) => {
          acc.sum_amount += parseFloat(d.sum_amount)
          acc.sum_count += parseFloat(d.sum_count)
          acc.count += parseFloat(d.sum_count)
          acc.fee += parseFloat(d.sum_amount)
          acc.discount += parseFloat(d.sum_discount)
          acc.tax += parseFloat(d.sum_tax)
          return acc
        }, {
          sum_count: 0,
          sum_amount: 0,
          count: 0,
          fee: 0,
          discount: 0,
          tax: 0,
          sumCurrency: 0,
          sum: 0,
          cost: 0,
          profit: 0,
        })
        return totals
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          ;(app.tableOptions.sortBy || []).map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            if (index > -1) {
              app.sortBy.push(app.headers[index].table)
            }
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      dateType () {
        this.getItems()
      },
      loading (val) {
        if (!val && this.isDesktopListViewport) {
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.scheduleDesktopTableHeightUpdate()
          })
        }
      },
      isDesktopListViewport (val) {
        if (val) {
          this.$nextTick(() => {
            this.updateDesktopTableHeight()
            this.bindListViewportObserver()
          })
        } else {
          this.unbindListViewportObserver()
          this.tableHeight = window.innerHeight - 245
        }
      },
    },
    activated () {
    // this.getItems()
      if (this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver()
          this.scheduleDesktopTableHeightUpdate()
        })
      }
    },
    beforeMount () {
      if (this.$route.name === 'sellIProductItemsList') {
        this.type = 'sell'
      }
      if (this.$route.name === 'sellIProductGroupItemsList') {
        this.type = 'sell'
        this.groupPerProductGroup = 'active'
      }
      if (this.$route.name === 'presaleProductItemsList') {
        this.type = 'presale'
      }
      if (this.$route.name === 'purchaseProductItemsList') {
        this.type = 'purchase'
      }
      if (this.$route.name === 'returnPurchaseProductItemsList') {
        this.type = 'returnPurchase'
      }
      if (this.$route.name === 'returnSellProductItemsList') {
        this.type = 'returnSell'
      }
      this.headers = [
        {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
        {
          text: this.$t('product'),
          sortable: false,
          value: 'product.name',
        },
        {
          text: this.$t('group'),
          sortable: false,
          value: 'product.group.name',
        },
        {
          text: this.$t('unit'),
          sortable: false,
          value: 'product.unit.fame',
        },
        {
          text: this.$t('count'),
          sortable: false,
          value: 'sum_count',
        },
        {
          text: this.$t('discount'),
          sortable: false,
          value: 'sum_discount',
        },
        {
          text: this.$t('tax'),
          sortable: false,
          value: 'sum_tax',
        },
        {
          text: this.$t('sum'),
          sortable: false,
          value: 'sum_amount',
        },
      ]
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      reorderPinnedHeaders(this.headers, {
        locked: this.productItemsListLockedColumns,
        anchor: "actions",
      })
      this.loadProductItemsListColumnSettings()
    },
    mounted () {
      // Preserve existing page size for this report (was options.itemsPerPage)
      this.tableOptions.itemsPerPage = 500
      if (this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver()
          this.updateDesktopTableHeight()
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.scheduleDesktopTableHeightUpdate()
          })
        })
      }
    },
    deactivated () {
      this.unbindListViewportObserver()
    },
    beforeDestroy () {
      this.unbindListViewportObserver()
      if (this.listViewportRaf) {
        cancelAnimationFrame(this.listViewportRaf)
        this.listViewportRaf = null
      }
    },
    methods: {

      resetFilters () {
        var app = this
        ;[
          'product', 'sellStatus', 'currencyFilter',
          'fromAmount', 'toAmount', 'fromNumber', 'toNumber',
          'fromDate', 'toDate', 'tag', 'group', 'cat1', 'cat2',
          'branch', 'entrepot', 'groupPerProductGroup',
        ].forEach(function (k) { app[k] = null })
      },
      resolveRefEl (ref) {
        if (!ref) return null
        return ref.$el || ref
      },
      onResize () {
        if (this.isDesktopListViewport) {
          this.updateDesktopTableHeight()
          return
        }
        this.tableHeight = window.innerHeight - 245
      },
      scheduleDesktopTableHeightUpdate () {
        if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf)
        this.listViewportRaf = requestAnimationFrame(() => {
          this.listViewportRaf = null
          this.updateDesktopTableHeight()
        })
      },
      updateDesktopTableHeight () {
        if (!this.isDesktopListViewport) {
          this.tableHeight = window.innerHeight - 245
          return
        }
        const rootEl = this.resolveRefEl(this.$refs.listRoot)
        const toolbarEl = this.resolveRefEl(this.$refs.listToolbar)
        const summaryEl = this.resolveRefEl(this.$refs.listSummary)
        const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
        const tableEl = this.resolveRefEl(this.$refs.listTable)
        if (!rootEl || !tableColEl) {
          this.tableHeight = window.innerHeight - 245
          return
        }
        const rootStyle = window.getComputedStyle(rootEl)
        const rootPadding =
          (parseFloat(rootStyle.paddingTop) || 0) +
          (parseFloat(rootStyle.paddingBottom) || 0)
        const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0
        let summaryHeight = 0
        if (summaryEl) {
          const summaryVisible =
            summaryEl.offsetParent !== null ||
            summaryEl.getClientRects().length > 0
          if (summaryVisible) {
            const summaryStyle = window.getComputedStyle(summaryEl)
            summaryHeight =
              summaryEl.offsetHeight +
              (parseFloat(summaryStyle.marginTop) || 0) +
              (parseFloat(summaryStyle.marginBottom) || 0)
          }
        }
        const colStyle = window.getComputedStyle(tableColEl)
        const colPadding =
          (parseFloat(colStyle.paddingTop) || 0) +
          (parseFloat(colStyle.paddingBottom) || 0)
        const footerEl = tableEl
          ? tableEl.querySelector('.v-data-footer')
          : null
        const footerHeight = footerEl ? footerEl.offsetHeight : 0
        const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null
        const tableMargins = tableStyle
          ? (parseFloat(tableStyle.marginTop) || 0) +
            (parseFloat(tableStyle.marginBottom) || 0)
          : 0
        const available =
          rootEl.clientHeight -
          rootPadding -
          toolbarHeight -
          summaryHeight -
          colPadding -
          footerHeight -
          tableMargins -
          3
        this.tableHeight = Math.max(180, Math.floor(available))
      },
      bindListViewportObserver () {
        if (typeof ResizeObserver === 'undefined') return
        this.unbindListViewportObserver()
        const rootEl = this.resolveRefEl(this.$refs.listRoot)
        const summaryEl = this.resolveRefEl(this.$refs.listSummary)
        const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
        const tableEl = this.resolveRefEl(this.$refs.listTable)
        const footerEl = tableEl ? tableEl.querySelector('.v-data-footer') : null
        if (!rootEl && !summaryEl && !tableColEl) return
        this.listViewportObserver = new ResizeObserver(() => {
          this.scheduleDesktopTableHeightUpdate()
        })
        if (rootEl) this.listViewportObserver.observe(rootEl)
        if (summaryEl) this.listViewportObserver.observe(summaryEl)
        if (tableColEl) this.listViewportObserver.observe(tableColEl)
        if (footerEl) this.listViewportObserver.observe(footerEl)
      },
      unbindListViewportObserver () {
        if (this.listViewportObserver) {
          this.listViewportObserver.disconnect()
          this.listViewportObserver = null
        }
      },
      loadProductItemsListColumnSettings () {
        var app = this
        if (!app.headers || !app.headers.length) return
        loadColumnSettings(app, app.productItemsListColumnPersistKey).then(function (snapshot) {
          if (!snapshot || !snapshot.length) return
          applyColumnSettings(app.headers, snapshot, {
            locked: app.productItemsListLockedColumns,
            anchor: "actions",
          })
          app.$forceUpdate()
        })
      },
      openComponent (component, id) {
        this.dialogData = {
          name: component,
          id: id,
        }
        this.innerComponent = true
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: this.type + 'Edit', params: { id: item.head.uid } })
      },
      print (item) {
        this.printId = item.head.uid
        this.invoicePrintDialog = true
      },
      getItems () {
        var app = this
        app.filter = false
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoiceReport', {
          params: {
            select: 'productItems',
            dateType: app.dateType,
            groupPerProductGroup: app.groupPerProductGroup,
            group: app.group,
            cat1: app.cat1,
            cat2: app.cat2,
            branch: app.branch,
            entrepot: app.entrepot,
            product: app.product,
            search: app.search,
            account: app.account,
            fromDate: app.fromDate,
            toDate: app.toDate,
            fromAmount: app.fromAmount,
            toAmount: app.toAmount,
            fromNumber: app.fromNumber,
            toNumber: app.toNumber,
            currency: app.currencyFilter,
            page: (app.allRows ? app.excelPage : app.tableOptions.page),
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.tableOptions,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            app.start = res.start
            app.end = res.end
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'invoice/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            deleteItems: app.selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            type: app.$t(d.head.type),
            product: (d.product ? d.product.name : ''),
            unit: (d.product && d.product.unit ? d.product.unit.fame : ''),
            count: app.$numberFormat((d.sum_count ? d.sum_count : 0)),
            fee: app.$numberFormat((d.sum_amount ? d.sum_amount : 0)),
            discount: app.$numberFormat(d.sum_discount),
            tax: app.$numberFormat(d.sum_tax),
          })
        })
      },
      fishprint () {
        var body = this.$refs.refPrint.innerHTML
        var html = '<!DOCTYPE html><html><meta charset="utf-8"><head>' +
          '<style scoped>' +
          '  thead > tr > td{border: solid 1px #171717;padding: 5px;font-size: 9px}' +
          '  tbody > tr > td{border: solid 1px #171717;padding: 5px;font-size: 9px}' +
          '  tfoot > tr > td{border: solid 1px #171717;padding: 5px;font-size: 9px}' +
          '  body{font-family: "IRANSans(FaNum)";}}' +
          '@page {' +
          '    padding: 0mm;' +
          '    margin: 0mm;' +
          ' }' +
          ' @media print {' +
          '    margin: 0mm; padding: 0mm' +
          '}' +
          '' +
          '</style>' +
          '' +
          '</head>' +
          '<body style="width:100;direction: rtl">' + body +
          '</body>' +
          '</html>'
        const socket = new WebSocket('ws://localhost:4022/Print')
        socket.onopen = function (event) {
          socket.send(html)
        }
      },
    },
  }
</script>

<style scoped>
#printTable > thead > tr > td{border: solid 1px #171717;padding: 5px;font-size: 10px}
#printTable > tbody > tr > td{border: solid 1px #171717;padding: 5px;font-size: 10px}
#printTable > tfoot > tr > td{border: solid 1px #171717;padding: 5px;font-size: 10px}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";
</style>
